import { createSlice } from '@reduxjs/toolkit';


const userSlice = createSlice({
    name: 'user',
    initialState: { user: null, isAuthenticated: false },
    reducers: {
      setUser: (state, action) => {
        state.user = action.payload;
        state.isAuthenticated = true;
      },
      clearUser: (state) => {
        state.user = null;
      },
      clearAuthenticated: (state) => {
        state.isAuthenticated = false;
      },
      setAuthenticated: (state) => {
        state.isAuthenticated = true;
      },
    },
});

export const { setUser, clearUser, setAuthenticated, clearAuthenticated } = userSlice.actions;

export default userSlice.reducer;

